module.exports = __webpack_public_path__ + "static/media/avatar_new_bg.3a721873.png";